import "@hotwired/turbo-rails";

import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import { TurboMount } from "turbo-mount";
import { registerComponent } from "turbo-mount/react";

import CalBookingController from "~/controllers/cal_booking_controller";
import ModalController from "~/controllers/modal_controller";
import ModalTriggerController from "~/controllers/modal_trigger_controller";
import MissiveChatController from "~/controllers/missive_chat_controller";
import BridgeAuthenticationStatusController from "~/controllers/bridge/authentication_status_controller";
import StaticBenchmarkPageChart from "~/components/StaticBenchmarkPageChart";

import { setUpSentry } from "~/lib/sentry";
import { setUpAnalytics } from "~/lib/analytics";
import { setUpXAds } from "~/lib/x_ads";

setUpSentry();

const application = Application.start();
application.debug = false;
window.Stimulus = application;
const turboMount = new TurboMount();

const splashControllers = import.meta.glob("~/controllers/splash/**/*_controller.js", { eager: true });
registerControllers(application, splashControllers);
registerComponent(turboMount, "StaticBenchmarkPageChart", StaticBenchmarkPageChart);

application.register("cal-booking", CalBookingController);
application.register("modal", ModalController);
application.register("modal-trigger", ModalTriggerController);
application.register("missive-chat", MissiveChatController);
application.register("bridge--authentication-status", BridgeAuthenticationStatusController);

setUpAnalytics();
setUpXAds();

// Splash CSS sets `scroll-behavior: smooth` on <html>, which causes Turbo's
// post-navigation scrollTo(0, 0) to animate slowly rather than jump. Suppress
// it during the visit; restore on load so in-page anchor clicks (e.g. nav
// "Product" → #features) still smooth-scroll.
document.addEventListener("turbo:before-visit", () => {
  document.documentElement.style.scrollBehavior = "auto";
});
document.addEventListener("turbo:load", () => {
  document.documentElement.style.scrollBehavior = "";
});
